import { useLocalizeMessage } from 'libs.nucleus';
import { getCaregiverDisplayNameCount } from '../../helpers/caregivers.helpers';
export const useTranslateDisplayName = () => {
    const translate = useLocalizeMessage();
    return (displayName) => {
        const count = getCaregiverDisplayNameCount(displayName);
        return translate('label.caregiver.count', { count });
    };
};
